import TextAreaField from './TextAreaField.component';

export default TextAreaField;
